import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';
import { Loader } from 'rsuite';
import styled from 'styled-components';
import { AppConfig } from '../../../helpers/config';
import { awsS3presignedRequest } from '../../../services/fbm-api';
import { createFilename } from '../../../helpers/guestProfilePhoto';

const Wrapper = styled.div`
  min-width: 150px;
  min-height: 130px;
  text-align: center;
  border: 1px solid #efefef;
`;

const StyledImage = styled.img`
  max-width: 175px;
  max-height: 130px;
`;

const ProfilePhoto = ({ guestId, reload, setHasProfilePhoto, ...props }) => {
  const [imgSrc, setImgSrc] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(
    () => {
      if (!guestId) return;
      setLoading(true);
      const filename = createFilename(guestId);
      const bucket = get('buckets.images', AppConfig);
      const body = { bucket, filename, method: 'get' };
      awsS3presignedRequest({ body }).then(({ url }) => {
        setImgSrc(url);
        setLoading(false);
        setHasProfilePhoto(!!url);
      });
    },
    [guestId, reload]
  );

  return (
    <Wrapper {...props}>
      {loading ? (
        <Loader center />
      ) : (
        <StyledImage alt="Empty" src={imgSrc || '/img/no-image.jpeg'} />
      )}
    </Wrapper>
  );
};

ProfilePhoto.propTypes = {
  guestId: PropTypes.string,
  reload: PropTypes.number, // Set to random value to force reload
  setHasProfilePhoto: PropTypes.func.isRequired
};

ProfilePhoto.defaultProps = {
  guestId: '',
  reload: 0
};

export default ProfilePhoto;
